import React from "react";
import useClientConfig from "../../../../../config/careers/clientConfig";

const TrueitBanner = () => {
    const {clientAssetsLink} = useClientConfig();

    return (
        <div>
            <img src={clientAssetsLink + "/banner.jpg"} alt="Banner" />
        </div>
    );
};

export default TrueitBanner;